import { createApp,h } from 'vue'
import maprouter from './router'
import App from './App.vue'
import axios from 'axios'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMagnifyingGlass, faArrowUp, faArrowDown, faX, faBuildingCircleExclamation, faIcons, faList } from '@fortawesome/free-solid-svg-icons'
import { faFaceGrinWide, faFaceMeh, faFaceSadCry } from '@fortawesome/free-regular-svg-icons'

library.add(faList)
library.add(faIcons)
library.add(faBuildingCircleExclamation)
library.add(faMagnifyingGlass)
library.add(faArrowUp)
library.add(faArrowDown)
library.add(faX)
library.add(faFaceGrinWide)
library.add(faFaceMeh)
library.add(faFaceSadCry)

axios.defaults.baseURL = process.env.VUE_APP_WS_URL
axios.defaults.withCredentials = false
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// 5. Create and mount the root instance.
const app  = createApp({
    render: ()=>h(App)
});
// Make sure to _use_ the router instance to make the
// whole app router-aware.
app.use(maprouter)

app.use(VueGoogleMaps, {
  load: {
    v: 3.53,
    key: 'AIzaSyBrOp6Lf34nrawOcrqm-1705cL6EeeDliQ',
    libraries: 'drawing'
  },
  autoBindAllEvents: true
})

app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')